import { colorPalette } from '@sharefiledev/antd-config';
import { Button, Flex, Modal } from 'antd';
import { useHistory } from 'react-router-dom';
import { useAppStore } from '../../../Common/store';
import {
	SignatureRequestQuickFlowDrawerCloseTypes,
	SignatureRequestTypes,
} from '../../../constants';
import { startDocumentPath } from '../../../routes';
import { SendSignatureRequestFooterAnalyticsIds } from '../../../Tracking/events';
import { t } from '../../../util';

// TODO: Update the button text based on the current step
const getButtonText = currentStep => {
	return t(currentStep);
};

export const SignatureRequestDrawerFooter = () => {
	const [modal, contextHolder] = Modal.useModal();
	const [signatureRequestMetadata, updateSignatureRequestMetadata] = useAppStore(
		state => [state.signatureRequestMetadata, state.updateSignatureRequestMetadata]
	);
	const [docmentTransaction, rsDocument] = useAppStore(state => [
		state.document_transaction,
		state.rsDocument,
	]);

	const history = useHistory();

	const onNextButtonClick = async () => {};

	const handleCustomize = () => {
		setTimeout(() => {
			history.push({
				pathname: startDocumentPath.replace(':transactionId', docmentTransaction?.id),
				state: {
					redirectPath: signatureRequestMetadata?.redirectPath ?? '/',
					createdFromResource: true,
					docGenRequestType: SignatureRequestTypes.Customized,
					docGenDocumentId: signatureRequestMetadata?.documentRID
						?.split('document-')
						?.pop(),
				},
			});
		}, 500);

		updateSignatureRequestMetadata({
			drawerCloseType: SignatureRequestQuickFlowDrawerCloseTypes.Customize,
		});
	};

	return (
		<Flex
			justify="space-between"
			align="center"
			style={{
				background: colorPalette.neutral1,
				flexDirection: 'row-reverse',
				visibility: rsDocument ? 'visible' : 'hidden',
				width: '100%',
			}}
		>
			{contextHolder}

			<div>
				<Button
					onClick={handleCustomize}
					data-analytics-id={SendSignatureRequestFooterAnalyticsIds.Customize}
				>
					{t('sendSignatureRequestQuickFlow.footer.customize')}
				</Button>

				<Button type="primary" onClick={onNextButtonClick}>
					{getButtonText('Next')}
				</Button>
			</div>
		</Flex>
	);
};
